// extracted by mini-css-extract-plugin
export default {"toolsContainer":"Brands_toolsContainer__Uxfsi","gridContainer":"Brands_gridContainer__HqaXg"};